import React from "react";
import { emailSuggestion } from "../lib/emailCheck";

// Shows "Did you mean …@gmail.com?" under an email field. onUse(fixed) swaps it in.
export default function EmailHint({ email, onUse, dark = false, className = "" }) {
    const s = emailSuggestion(email);
    if (!s) return null;
    return (
        <div className={`rounded-xl px-3 py-2 text-xs flex flex-wrap items-center gap-x-2 gap-y-1 ${className}`} role="alert" data-testid="email-hint"
            style={dark ? { background: "rgba(224,122,95,.12)", border: "1px solid rgba(224,122,95,.5)", color: "#F3EFE7" } : { background: "#fff4ec", border: "1px solid #f0b48f", color: "#5a2d12" }}>
            <span>Check your email. Did you mean <b>{s}</b>?</span>
            <button type="button" onClick={() => onUse(s)} className="underline font-bold" data-testid="email-hint-use">Yes, use this</button>
        </div>
    );
}
